<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  data() {
    return { }
  },
  created() {
    },
    methods: {
    }
  }
</script>

<style>
  @import "../static/css/main.css";
  @import "../static/css/color-dark.css";

</style>



// WEBPACK FOOTER //
// src/App.vue